<template>
  <div>
    <Assignments v-if="this.$store.state.user"/>
    <Login v-else/>
  </div>
</template>

<script>
import Login from '../components/Login'
import Assignments from '../components/Assignments'

export default {
  components: {
    Login,
    Assignments
  },
  mounted() {
    this.$store.commit('setAssignment', null)
    this.$store.commit('setNav', null)
  }
}
</script>
